module.exports = __webpack_public_path__ + "static/RUmobSlide4-209631c26855890ed063c961cf89ca56.jpg";